module.exports = __webpack_public_path__ + "static/media/figure19.7229ae66.png";